export const labelFields = [
    "sjomerke_nr",
    "navn",
    "beskrivelse",
    "byggehoyde",
    "lys_hoyde",
    "karakter",
    "periode",
    "rekkevidde",
    "lysstyrke",
    "opprettet_dato",
    "oppdatert_dato",
    "kategori",
    "nfs_status",
    "retningslys_retning",
    "beliggenhet",
    "sted",
    "morsetegn",
    "toppmerke_retning",
];

export const labelFieldsDisplayNames: { [key: string]: string } = {
    sjomerke_nr: "Sjømerke nr",
    navn: "Navn",
    beskrivelse: "Beskrivelse",
    byggehoyde: "Byggehøyde",
    lys_hoyde: "Lyshøyde",
    karakter: "Karakter",
    periode: "Periode",
    rekkevidde: "Rekkevidde",
    lysstyrke: "Lysstyrke",
    opprettet_dato: "Opprettet dato",
    oppdatert_dato: "Oppdatert dato",
    kategori: "Kategori",
    nfs_status: "NFS status",
    retningslys_retning: "Retningslys retning",
    beliggenhet: "Beliggenhet",
    sted: "Sted",
    morsetegn: "Morsetegn",
    toppmerke_retning: "Toppmerke retning",
};

export enum NauticalClasses {
    NN_Ukjent = 0,
    LA_Lanterne = 1,
    LB_Lysboeye = 2,
    FL_Fyrlykt = 3,
    FS_Fyrstasjon = 4,
    HIB_HurtigbaatmerkeMedIndirekteBelysning = 5,
    IB_IndirekteBelysning = 6,
    RA_Racon = 7,
    OV_Overett = 11,
    SG_Stang = 21,
    VA_Varde = 22,
    BK_Baake = 23,
    ST_Stake = 31,
}

export enum FeatureClasses {
    Lys = 0,
    IB = 1,
    Sektorlinje = 2,
    Sektorflate = 3,
    Racon = 4,
    Fastsjømerke = 5,
    Flytendemerke = 6,
    Overettlinjelys = 7,
    Overettlinjemerke = 8,
    Farledlenke = 9,
    Sikkerhetsareal = 10,
    Farledsareal = 11,
    Elektroskap = 12,
    Sjøkabel = 13,
    Dybdedataindex = 14,
    Skilt = 15,
    Flytendemerkeinnmålt = 34,
    Hjelpepunkt = 35,
    Fundament = 16,
    KjettingInfo = 17,
    LysInfo = 18,
    Lyssektor = 19,
    Skjerming = 20,
    StakeInfo = 21,
    CandelaCL = 22,
    KarakterCL = 23,
    Versjonstilgang = 24,
    Farled_FastSjomerke = 25,
    Farled_FlytendeMerke = 26,
    Farled_IB = 27,
    Farled_Lys = 28,
    Farled_Racon = 29,
    Lys_FlytendeMerke = 30,
    Lys_IB = 31,
    Lys_Racon = 32,
    EFSmeldingsmaler = 36,
    FlytendemerkeTildelt = 37,
}

/**
 * The operative feature server does not publish all the layers and tables that the
 * editing feature server does. Creating a FeatureLayer for a layer id that does not
 * exist there results in invalid api calls, so only these ids may be used against
 * AppConfig.OperativeObjectsFeatureServer.
 */
export const OperativeFeatureServerLayerIds: ReadonlySet<number> = new Set<number>([
    FeatureClasses.Lys,
    FeatureClasses.IB,
    FeatureClasses.Sektorlinje,
    FeatureClasses.Sektorflate,
    FeatureClasses.Racon,
    FeatureClasses.Fastsjømerke,
    FeatureClasses.Flytendemerke,
    FeatureClasses.Overettlinjelys,
    FeatureClasses.Overettlinjemerke,
    FeatureClasses.Elektroskap,
    FeatureClasses.Sjøkabel,
    FeatureClasses.Dybdedataindex,
    FeatureClasses.Skilt,
    FeatureClasses.Fundament,
    FeatureClasses.KjettingInfo,
    FeatureClasses.LysInfo,
    FeatureClasses.Lyssektor,
    FeatureClasses.Skjerming,
    FeatureClasses.StakeInfo,
]);

/**
 * True if the given layer id exists on the operative feature server.
 */
export const isOperativeLayerId = (layerId: number | string | null | undefined): boolean => {
    if (layerId === null || layerId === undefined || layerId === "") {
        return false;
    }
    return OperativeFeatureServerLayerIds.has(Number(layerId));
};
